import Alpine from "alpinejs";
import gsap from "gsap";

export const homeMvAnimation = () => {
  Alpine.data("homeMvAnimation", () => ({
    timeline: null as gsap.core.Timeline | null,
    init() {
      const root = this.$root as HTMLElement;
      const englishPaths = Array.from(
        root.querySelectorAll("#home-mv-text-english path"),
      ) as SVGPathElement[];
      const japaneseGroup = root.querySelector("#home-mv-text-japanese") as SVGGElement | null;
      const sliderWrappers = Array.from(
        root.querySelectorAll("[data-slider-wrapper]"),
      ) as HTMLElement[];

      if (englishPaths.length === 0 && !japaneseGroup && sliderWrappers.length === 0) return;

      gsap.set(englishPaths, { autoAlpha: 0, x: 16 });
      gsap.set(japaneseGroup, { autoAlpha: 0 });
      gsap.set(sliderWrappers, { filter: "brightness(200%)" });

      const tl = gsap.timeline();

      tl.to(sliderWrappers, {
        filter: "brightness(100%)",
        duration: 0.8,
        stagger: 0.12,
      })
        .to(
          englishPaths,
          {
            x: 0,
            autoAlpha: 1,
            duration: 0.8,
            stagger: 0.05,
            ease: "power2.out",
          },
          "<",
        )
        .to(
          japaneseGroup,
          {
            autoAlpha: 1,
            duration: 1.6,
            ease: "power2.out",
          },
          "-=1.0",
        );

      this.timeline = tl;
    },
    destroy() {
      this.timeline?.kill();
      this.timeline = null;
    },
  }));
};
